export const SELECTED_CATEGORY_ID_KEY = 'selectedCategoryId';

export const DEFAULT_TRENDS = {
	period: 'weekly',
	win_rate: {
		current: 60,
		previous: 0,
		delta: 60,
	},
	avg_pnl: {
		current: 10,
		previous: 0,
		delta: 10,
	},
	trade_count: {
		current: 5,
		previous: 0,
		delta: 5,
	},
};
